// module
import * as R from 'ramda'
// actions
import { queueRetryDec } from './queue.action'
// view
import { queueView } from './queue.view'
import { getHook } from '../hooks'
// store
import { dispatch } from '../../setup/redux'

export const handleRetryIteration = () => {
  const queue = queueView()

  // low-priority work done after reducer work
  setTimeout(() => {
    const rejectedMessages = R.reject(R.prop('retry'), queue)
    if (rejectedMessages.length)
      getHook('onFailure')(R.pluck('data', rejectedMessages))
  }, 0)

  dispatch(queueRetryDec())
}
